"use client";

import Image from "next/image";
import { useI18n } from "@/lib/i18n/LanguageProvider";
import { useTrackSection } from "@/hooks/useTrackSection";

const Partners = () => {
  const { t } = useI18n();
  const sectionRef = useTrackSection<HTMLElement>("partners");
  // Row 1: ischool, Tuệ Đức, Greenfield, UKA, Newton Grammar School, I Can School, Nhựt Tân
  const row1Logos = [
    { src: "/assets/partners/ischool.png", alt: "iSchool" },
    { src: "/assets/partners/tue-duc.png", alt: "Tuệ Đức" },
    { src: "/assets/partners/greenfield.png", alt: "Greenfield School" },
    { src: "/assets/partners/uka.png", alt: "UK Academy" },
    { src: "/assets/partners/newton-grammar.jpg", alt: "Newton Grammar School" },
    { src: "/assets/partners/ican-school.jpg", alt: "I Can School" },
    { src: "/assets/partners/nhut-tan.png", alt: "Nhut Tan School" },
  ];

  // Row 2: Remaining logos
  const row2Logos = [
    { src: "/assets/partners/h123.png", alt: "H123 English Afterschool Center" },
    { src: "/assets/partners/ican-speak.png", alt: "I Can Speak English" },
    { src: "/assets/partners/able.png", alt: "ABLE" },
    { src: "/assets/partners/evas.png", alt: "EVAS Future Building" },
    { src: "/assets/partners/light-up-english.png", alt: "Light Up English" },
    { src: "/assets/partners/newstar.png", alt: "New Star English" },
    { src: "/assets/partners/msn-kids.png", alt: "MSN Kids" },
    { src: "/assets/partners/eso.png", alt: "ESO Online English Academy" },
    { src: "/assets/partners/tono.png", alt: "TONO Tomorrow Is Now" },
    { src: "/assets/partners/cb-centres.png", alt: "CB Centres" },
  ];

  return (
    <section ref={sectionRef} id="partners" className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-foreground py-5">
          {t.partners.heading}
        </h2>

        <div className="overflow-hidden space-y-6">
          {/* Row 1 - sliding left */}
          <div className="flex gap-8">
            <div className="flex gap-8 animate-slide-left">
              {[...row1Logos, ...row1Logos, ...row1Logos].map(
                (partner, index) => (
                  <div
                    key={`row1-${index}`}
                    className="flex-shrink-0 w-48 h-24 bg-background rounded-lg shadow-sm flex items-center justify-center border border-border p-4"
                  >
                    <Image
                      src={partner.src}
                      alt={partner.alt}
                      width={160}
                      height={80}
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                )
              )}
            </div>
          </div>

          {/* Row 2 - sliding left */}
          <div className="flex gap-8">
            <div className="flex gap-8 animate-slide-left">
              {[...row2Logos, ...row2Logos, ...row2Logos].map(
                (partner, index) => (
                  <div
                    key={`row2-${index}`}
                    className="flex-shrink-0 w-48 h-24 bg-background rounded-lg shadow-sm flex items-center justify-center border border-border p-4"
                  >
                    <Image
                      src={partner.src}
                      alt={partner.alt}
                      width={160}
                      height={80}
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Partners;
